import React from 'react';
import styles from './FullPageLoader.module.scss';
import { LottieAnimation } from '@/components/common/LottieAnimation/LottieAnimation';

const FullPageLoader: React.FC = () => {
  return (
    <div className={styles.backdrop} data-automation="backdrop">
      <LottieAnimation animationName={'loader_loop'} width={360} height={360} />
    </div>
  );
};

export default FullPageLoader;
